export async function blobToDataUrl(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onabort = reject;
        reader.onload = event => {
            try {
                if (!event.target?.result) {
                    throw new Error('Data url could not be resolved');
                }

                if (event.target.result instanceof ArrayBuffer) {
                    throw new Error('Data url not instance of string');
                }

                resolve(event.target.result);
            } catch (error) {
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
